<script setup lang="ts">
import Burger from '~/components/modules/burger/Burger.vue';
import Menu from '~/components/modules/menu/Menu.vue';
import Logo from '~/components/modules/logo/Logo.vue';

const {
    isMenuOpen,
    menuClasses,
    closeMenu,
} = useHeaderMenu();
</script>

<template>
    <header class="header">
        <div class="container header__inner">
            <Logo class="header__logo"/>

            <Menu
                class="header__menu"
                :class="menuClasses"
                @menu-item-click="closeMenu"
            />

            <Burger
                v-model="isMenuOpen"
                class="header__burger"
            />
        </div>
    </header>
</template>

<style scoped lang="scss">
@import "styles/header";
</style>
